import Cookies from 'js-cookie';
import {
	kAuthRoot,
	kAuthPath,
	kScope,
	kResponseType,
	kWebRoot,
	kClientId,
	kCookieKey,
	kApiStartPath,
	kApiEndPath,
	kCodeVerifierKey,
	kCodeChallengeMethod,
} from './constants';

export const generateRandom = () => {
	const radix = 36;
	return Date.now().toString() + Math.random().toString(radix);
};

export const updateWindowLocationUrl = url => {
	window.location.href = url;
};

const generateCodeVerifier = () => {
	const arrayLength = 28;
	const randomArray = new Uint32Array(arrayLength);
	window.crypto.getRandomValues(randomArray);
	const byteToHexRadix = 16;
	const sliceLength = -2;
	const byteToHexString = dec =>
		`0${dec.toString(byteToHexRadix)}`.slice(sliceLength);
	return Array.from(randomArray, byteToHexString).join('');
};

const generateCodeChallenge = async codeVerifier => {
	const hashed = await window.crypto.subtle.digest(
		'SHA-256',
		new TextEncoder().encode(codeVerifier)
	);
	return btoa(String.fromCharCode.apply(null, new Uint8Array(hashed)))
		.replace(/\+/g, '-')
		.replace(/\//g, '_')
		.replace(/=+$/, '');
};

export const createAuthURI = async () => {
	const state = generateRandom();
	const redirectUri = encodeURIComponent(`${kWebRoot}/${kApiStartPath}`);
	const responseType = encodeURIComponent(kResponseType);
	const scope = encodeURIComponent(kScope);
	const codeVerifier = generateCodeVerifier();
	Cookies.set(kCodeVerifierKey, codeVerifier);
	const codeChallenge = await generateCodeChallenge(codeVerifier);
	const url = `${kAuthRoot}/${kAuthPath}`;
	return `${url}?response_type=${responseType}&client_id=${kClientId}&redirect_uri=${redirectUri}&scope=${scope}&state=${state}&code_challenge=${codeChallenge}&code_challenge_method=${kCodeChallengeMethod}`;
};

export const logout = () => {
	const url = `${kWebRoot}/${kApiEndPath}`;
	Cookies.remove(kCookieKey);
	sessionStorage.clear();
	updateWindowLocationUrl(url);
};

export const renewToken = async () => {
	const url = await createAuthURI();
	const silentRenewFrame = document.getElementById('silentRenew');
	silentRenewFrame.setAttribute('src', url);
};



// WEBPACK FOOTER //
// ./src/sso-auth/helpers.js